<template>
    <article class="download-coin-wrap">
        <header>
            <img src="../assets/download-coin-logo.png" alt="All Sepakbola">
            <h1>All Sepakbola</h1>
            <p> {{$t('bestApp')}}</p>
        </header>
        <section v-if="!isAndroid">
            <div class="invite-code">
                <input type="text" class="invite-code-input" readonly :value="inviteCode">
                <span class="copy" @click.prevent="copy()"><i class="icon-copy"></i>  {{$t('copy')}}</span>
            </div>
            <p>* {{$t('downloadForCoin')}}</p>

            <a href="#" class="btn" @click.prevent="copyAndDownload()">
                {{$t('download')}} <i class="icon-download"></i>
            </a>
        </section>
    </article>
</template>
<script>
    const utilObj = require('@/util/util.js');

    export default {
        data () {
            return {
                inviteCode: this.$route.query.invite_code,
                isAndroid: true
            };
        },
        head () {
            const title = this.$t('shareForCoin');
            const HOST = process.env.NODE_ENV === 'production' ? 'https://m-yinni.allsepakbola.net' : 'https://beta-m-yinni.allfootballapp.com';
            const shareUrl = HOST + this.$route.fullPath;
            return {
                title,
                meta: [
                    { name: 'twitter:card', content: 'summary_large_image' },
                    { name: 'twitter:site', content: '@allfootballapp' },
                    { name: 'twitter:creator', content: '@allfootballapp' },
                    { name: 'twitter:app:id:ipad', content: '' },
                    { name: 'twitter:title', content: title },
                    { name: 'twitter:image', content: 'https://allfootball-static.dongqiudi.com/n/public/favicon.ico' },
                    // facebook
                    { name: 'fb:app_id', content: 'summary_large_image' },
                    { name: 'og:url', content: shareUrl },
                    { name: 'og:type', content: 'article' },

                    // for twiter and facebook
                    { name: 'og:title', content: title },
                    { name: 'og:description', content: title },
                    { name: 'og:image', content: 'https://allfootball-static.dongqiudi.com/n/public/favicon.ico' },
                    { name: 'og:site_name', content: 'AllfootballOfficial' }
                ]
            };
        },
        created () {

        },
        mounted () {
            const browser = utilObj.detectUa();
            this.isAndroid = browser.isAndroid;
            const vm = this;
            if (browser.isAndroid) {
                let referrer = encodeURIComponent(`utm_source=share&utm_medium=app&utm_content=${this.inviteCode}&anid=admob`);
                location.href = `market://details?id=com.allfootball.news&referrer=${referrer}`;

                var _start = (new Date()).getTime();

                setTimeout(function () {
                    var _end = (new Date()).getTime();
                    if (_end - _start < 800) {
                        vm.isAndroid = false;
                    }
                }, 500);
            }
            if (window.history) {
                const fullPath = this.$route.fullPath;
                history.replaceState(null, 'share', '/home?utm_source=shareForAFCoin');
                history.pushState(null, 'share', fullPath);

                window.addEventListener('popstate', function (event) {
                    if (location.pathname !== '/news') {
                        location.reload();
                    }
                });
            }
        },
        methods: {
            copy () {
                const browser = utilObj.detectUa();
                const $input = this.$el.getElementsByClassName('invite-code-input');
                const el = $input && $input[0];
                if (!browser.isAndroid && el) {
                    const editable = el.contentEditable;
                    const readOnly = el.readOnly;
                    el.contentEditable = true;
                    el.readOnly = false;
                    const range = document.createRange();
                    range.selectNodeContents(el);
                    const sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                    el.setSelectionRange(0, 999999);
                    el.contentEditable = editable;
                    el.readOnly = readOnly;
                } else if (el && el.select) {
                    el.select();
                }

                try {
                    // 执行复制
                    document.execCommand('copy');
                    el.blur();
                    this.$toast(this.$t('copySuccess'));
                }
                catch (err) {
                    console.log(err);
                    // this.$toast('Copy failed');
                }
            },
            copyAndDownload () {
                this.copy();

                location.href = '/download?utm_source=shareForAFCoin';
            }
        }
    };
</script>
<style lang="less">
    html, body {
        height: 100%;
        background-color: #262a34;
        padding: 0;
        margin: 0;
    }

    .download-coin-wrap {
        width: 100%;
        height: 41.6rem;
        background: url(../assets/download-coin-bg.jpg) no-repeat;
        background-size: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        text-align: center;
        color: #fff;
        header {
            padding-top: 9.06rem;

            img {
                width: 4.25rem;
                margin-bottom: 2.125rem;
            }
            h1 {
                font-size: 2rem;
                font-weight: bold;
                line-height: 1;
                margin: 0;
            }
            p {
                font-size: 0.75rem;
            }
        }
        section {
            padding-top: 3.56rem;
            .btn {
                display: block;
                width: 12.375rem;
                height: 2.5rem;
                line-height: 2.5rem;
                // font-size: 1.32rem;
                font-size: 1.15rem;
                color: #fff;
                background: #16ac3a;
                margin: 2.75rem auto 1rem;
                border-radius: 2px;
                font-weight: bold;
            }

            .icon-download {
                background: url(../assets/download-coin-icon.png) no-repeat;
                background-size: 100%;
                display: inline-block;
                // width: 1rem;
                // height: 1rem;
                width: .8rem;
                height: .8rem;
            }

            .invite-code {
                display: block;
                width: 12.5rem;
                height: 2.375rem;
                background: #1c1d22;
                margin: 0 auto 1.2rem;
                border-radius: 4px;
                line-height: 2.375rem;
                font-size: 1.1rem;
                font-weight: bold;
                text-align: center;
                white-space: nowrap;
                input {
                    border: none;
                    background: none;
                    font-size: 1.1rem;
                    color: #b5bcc4;
                    width: 6.5rem;
                    text-align: center;
                    font-weight: bold;
                }
                .copy {
                    color: #16ac3a;
                    border-left: 1px solid #292c34;
                    padding-left: 0.5em;
                    // font-size: 0.8em;
                    font-size: 0.75em;
                }
                .icon-copy {
                    width: 1rem;
                    height: 1rem;
                    display: inline-block;
                    background: url(../assets/download-coin-copy.png) no-repeat;
                    background-size: 100%;
                    vertical-align: middle;
                }
            }

            p {
                width: 80%;
                margin: 0 auto;
                color: #b5bcc4;
                font-size: 0.9rem;
            }
        }
    }
</style>





// WEBPACK FOOTER //
// AppDownloadCoin.vue?6a3aa430